<template>
    <el-pagination style="padding-top:20px;text-align:right"
                   background
                   layout="prev, pager, next"
                   @current-change="changePage"
                   :page-size="listPagin.limit"
                   :total="listPagin.total">
    </el-pagination>
</template>

<script>
export default {
	name:'hxl-pagin',
	props:['listPagin'],
	data(){
		return{
			// listPagin: {
            //     page: 1,
            //     limit: 10,
            //     total: 0
            // },
		}
	},
	methods:{
		// 分页状态变化
        // changePage (e) {
		// 	this.form.pageNum = e
        //     this.listPagin.page = e
        //     this.getList();
        // },
	}
}
</script>

<style>
</style>